import Translations from "../../translations.json";

export type TranslationKey = keyof typeof Translations;

const INTL_LOCALE_MAP: Record<string, string> = {
  de: "de-DE",
  en: "en-US",
  es: "es-ES",
  et: "et-EE",
  fi: "fi-FI",
  fr: "fr-FR",
  ja: "ja-JP",
  ne: "ne-NP",
  ru: "ru-RU",
  tr: "tr-TR",
};

export function createTranslator(getLocale: () => string) {
  return (
    phraseKey: TranslationKey,
    params?: Record<string, string | number>
  ): string => {
    const locale = getLocale();
    const phrase = Translations[phraseKey];
    const template = locale in phrase ? (phrase as any)[locale] : phrase.en;

    if (!params) return template;
    return template.replace(
      /\{\{\s*([^}\s]+)\s*\}\}/g,
      (match: string, key: string) =>
        key in params ? String(params[key]) : match
    );
  };
}

export function getIntlLocale(locale?: string): string {
  if (!locale) {
    return "en-US";
  }

  return INTL_LOCALE_MAP[locale] ?? locale;
}
